

























































































import { Component, Watch } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import CreateXeroContactRequest from '@/models/Invoicing/CreateXeroContactRequest';
import { AppModule } from '@/store/modules/app';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import XeroContactSearchResult, { XeroContactSearchRequest, XeroContactSearchResponse } from '@/models/Invoicing/XeroContactSearchResult';
import UpdateCompanyAccountingDetailsRequest from "@/models/Companies/UpdateCompanyAccountingDetailsRequest";

@Component({
  name: 'CompanyAccountingDetailsEdit'
})
export default class CompanyAccountingDetailsEdit extends GiganautVueDialog {
  loading = false;
  loadingXeroContacts = false;
  selectedContact: XeroContactSearchResult | null = null;
  searchTimeout: number | null = null;
  searchTerm = '';

  get xeroContactSearchResults() {
    return CompanyDetailsModule.xeroContactSearchResults;
  }

  get xeroContactsList() {
    console.log('xeroContactSearchResults:', this.xeroContactSearchResults);
    
    // We now always expect lowercase camelCase format from the backend
    if (this.xeroContactSearchResults && this.xeroContactSearchResults.contacts) {
      console.log('Contacts found:', this.xeroContactSearchResults.contacts.length);
      
      // Map the contacts to ensure they have the expected properties
      return this.xeroContactSearchResults.contacts.map(contact => {
        return {
          contactId: contact.contactId,
          name: contact.name,
          emailAddress: contact.emailAddress,
          status: contact.contactStatus
        };
      });
    }
    
    return [];
  }

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (val) {
      // Dialog is opening
      this.selectedContact = null;
    } else {
      // Dialog is closing - add console log to see what's happening
      console.log('Dialog closing, selectedContact:', this.selectedContact);
    }
  }

  async searchXeroContacts() {
    // Don't search if search term is empty or too short
    if (!this.searchTerm || this.searchTerm.trim().length < 1) {
      console.log('Search term empty or too short:', this.searchTerm);
      return;
    }
    
    console.log('Starting search with term:', this.searchTerm);
    this.loadingXeroContacts = true;
    
    try {
      const request = new XeroContactSearchRequest();
      request.searchTerm = this.searchTerm.trim(); // This will be passed as 'search' in the API call
      request.page = 1; // Always start from first page for autocomplete
      request.pageSize = 20; // Increase page size for dropdowns
      
      console.log('Sending request with:', request);
      const result = await CompanyDetailsModule.searchXeroContacts(request);
      console.log('Search results:', result);
    } catch (e) {
      console.error('Error during search:', e);
      // Error handling is done in the store action
    } finally {
      this.loadingXeroContacts = false;
    }
  }

  // Called when the autocomplete is focused
  initXeroContactSearch() {
    if (this.searchTerm && this.searchTerm.trim().length > 0) {
      console.log('Focus event - initiating search with:', this.searchTerm);
      this.searchXeroContacts();
    }
  }

  // Called when the search input changes
  onSearchInputChange(val: string) {
    console.log('Search input changed:', val); // Debug
    
    // Cancel any pending timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    
    // Skip if the dialog is closed
    if (!this.dialog) {
      console.log('Dialog is closed, skipping search input change');
      return;
    }
    
    // If the search input is empty and the selected contact is not null, reset
    if (!val && this.selectedContact !== null) {
      this.selectedContact = null;
      return;
    }
    
    // Important: Update searchTerm property to match input
    this.searchTerm = val;
    
    // Debounce the search to avoid too many API calls
    this.searchTimeout = window.setTimeout(() => {
      // Skip if the dialog is closed (check again before searching)
      if (!this.dialog) {
        console.log('Dialog was closed during timeout, skipping search');
        return;
      }
      
      if (val && val.length > 0) { // Only search if we have at least 1 character
        console.log('Triggering search with term:', val); // Debug
        this.searchXeroContacts();
      }
    }, 500);
  }
  
  // Called when the selected item changes (including when cleared)
  onContactSelectionChange(value: XeroContactSearchResult | null) {
    // Only take action if we're clearing a previously selected value
    if (!value && this.selectedContact !== null) {
      this.selectedContact = null;
      // Don't call resetXeroContactSearch() here as it might cause a loop
    }
  }
  
  // Reset the Xero contact search state
  resetXeroContactSearch() {
    // Only set selectedContact to null if it isn't already null to avoid loops
    if (this.selectedContact !== null) {
      this.selectedContact = null;
    }
    
    // Only set searchTerm to empty if it isn't already empty to avoid loops
    if (this.searchTerm !== '') {
      this.searchTerm = '';
    }
  }
  
  // Cancel button handler
  cancel() {
    // Clear the search state before closing
    this.searchTerm = '';
    this.selectedContact = null;
    
    // Close the dialog
    this.dialog = false;
    
    console.log('Dialog canceled and state cleared');
  }
  
  async save() {
    const contactId = this.selectedContact?.contactId;
    
    // First save the data
    const request = new UpdateCompanyAccountingDetailsRequest();
    request.externalAccountingSystemId = contactId;
    request.updatedAt = CompanyDetailsModule.currentCompany.updatedAt;
    await CompanyDetailsModule.editCompanyAccountingDetails(request);
    
    // Clear the search state before closing
    this.searchTerm = '';
    this.selectedContact = null;
    
    // Close the dialog
    this.dialog = false;
    
    console.log('Dialog closed and state cleared');
  }
}
